import { __extends, __makeTemplateObject, __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';

var ProgressIndicatorStepState;
(function (ProgressIndicatorStepState) {
    ProgressIndicatorStepState["active"] = "active";
    ProgressIndicatorStepState["complete"] = "complete";
    ProgressIndicatorStepState["inactive"] = "inactive";
})(ProgressIndicatorStepState || (ProgressIndicatorStepState = {}));
var ProgressIndicatorIconName;
(function (ProgressIndicatorIconName) {
    ProgressIndicatorIconName["complete"] = "status__confirm";
})(ProgressIndicatorIconName || (ProgressIndicatorIconName = {}));
var DEFAULT_ACTIVE_STEP_INDEX = 0;
var DEFAULT_A11Y_PREFIX_TEXT = 'Step';
var PvdProgressIndicator = /** @class */ (function (_super) {
    __extends(PvdProgressIndicator, _super);
    // #endregion
    // #region LitElement lifecycles
    function PvdProgressIndicator() {
        var _this = _super.call(this) || this;
        //#endregion
        // #region LitElement properties
        _this.pvdActiveStepIndex = DEFAULT_ACTIVE_STEP_INDEX;
        _this.pvdA11yPrefixText = DEFAULT_A11Y_PREFIX_TEXT;
        _this.pvdA11yStepStateObject = ProgressIndicatorStepState;
        _this.pvdSteps = [];
        _this.pvdActiveStepIndex = DEFAULT_ACTIVE_STEP_INDEX;
        _this.pvdSteps = [];
        _this.pvdA11yPrefixText = DEFAULT_A11Y_PREFIX_TEXT;
        _this.pvdA11yStepStateObject = ProgressIndicatorStepState;
        return _this;
    }
    Object.defineProperty(PvdProgressIndicator, "scopedElements", {
        get: function () {
            return {
                'pvd-progress-indicator-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // # region private methods
    /**
     * Provides additional a11y text for the specific step
     * @param label the label used for the specific step
     * @param stepState the state the specific step is in
     * @param stepIndex the index of the step in the overall flow
     * @returns the string that is used for the step's SRO text
     */
    PvdProgressIndicator.prototype.getA11yText = function (label, stepState, stepIndex) {
        // users do not think of the first step to be 'step 0'; adding 1 so it's non-technical
        var stepInFlow = stepIndex + 1;
        return "".concat(this.pvdA11yPrefixText, " ").concat(stepInFlow, ", ").concat(label, ", ").concat(this.pvdA11yStepStateObject[stepState]);
    };
    /**
     * Based off index, this provides the step state that the node is in
     * @param stepIndex the index of the step in the overall flow
     * @returns the state that the specific node is in
     */
    PvdProgressIndicator.prototype.getStepState = function (stepIndex) {
        switch (true) {
            case stepIndex === this.pvdActiveStepIndex:
                return ProgressIndicatorStepState.active;
            case stepIndex < this.pvdActiveStepIndex:
                return ProgressIndicatorStepState.complete;
            default:
                return ProgressIndicatorStepState.inactive;
        }
    };
    /**
     * Creates a string of classes for a step in the Progress Indicator based off a class map
     * @param stepState the state the specific step is in
     */
    PvdProgressIndicator.prototype.stepClassMap = function (stepState) {
        var stepClassMap = {
            default: 'pvd-progress-indicator__step',
            modifierPrefix: 'pvd-progress-indicator__step',
            modifiers: [
                {
                    condition: true,
                    className: "".concat(stepState),
                },
            ],
        };
        return getClassName(stepClassMap);
    };
    /**
     * Generates the HTML of the icon that can be used instead of a div node with a border
     * @param stepState the state the specific step is in
     * @returns an HTML template of the icon that gets generated based on the step state
     */
    PvdProgressIndicator.prototype.renderIcon = function (stepState) {
        return this.scopeTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<pvd-progress-indicator-icon\n      pvd-name=\"", "\"\n      pvd-icon-class=\"pvd-progress-indicator__icon\"\n      pvd-size=\"large\"\n    ></pvd-progress-indicator-icon>"], ["<pvd-progress-indicator-icon\n      pvd-name=\"", "\"\n      pvd-icon-class=\"pvd-progress-indicator__icon\"\n      pvd-size=\"large\"\n    ></pvd-progress-indicator-icon>"])), ProgressIndicatorIconName[stepState]);
    };
    /**
     * Generates the HTML of the label and SRO text for the specific step
     * @param label the string that is passed in via pvdSteps used for the label
     * @param stepState the state the specific step is in
     * @param stepIndex the index of the step in the overall flow
     * @returns an HTML template of the label of of that specific step
     */
    PvdProgressIndicator.prototype.renderLabel = function (label, stepState, stepIndex) {
        return x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      <p aria-hidden=\"true\" class=\"pvd-progress-indicator__step-label\">", "</p>\n      <span class=\"pvd-progress-indicator__step-label-a11y-text\"\n        >", "\n      </span>\n    "], ["\n      <p aria-hidden=\"true\" class=\"pvd-progress-indicator__step-label\">", "</p>\n      <span class=\"pvd-progress-indicator__step-label-a11y-text\"\n        >", "\n      </span>\n    "])), label, this.getA11yText(label, stepState, stepIndex));
    };
    /**
     * Generates the HTML of the visual (bars and node) of a specific step
     * @param stepState the state that the specific step is in
     * @returns an HTML template of the visuals of that specific step
     */
    PvdProgressIndicator.prototype.renderStepVisual = function (stepState) {
        return x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<div class=\"pvd-progress-indicator__step-visual\">\n      <div class=\"pvd-progress-indicator__step-bar\"></div>\n      ", "\n      <div class=\"pvd-progress-indicator__step-bar\"></div>\n    </div>"], ["<div class=\"pvd-progress-indicator__step-visual\">\n      <div class=\"pvd-progress-indicator__step-bar\"></div>\n      ", "\n      <div class=\"pvd-progress-indicator__step-bar\"></div>\n    </div>"])), ProgressIndicatorIconName[stepState]
            ? x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), this.renderIcon(stepState)) : x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<div class=\"pvd-progress-indicator__step-node\"></div>"], ["<div class=\"pvd-progress-indicator__step-node\"></div>"]))));
    };
    /**
     * Generates the HTML needed for each step in the Progress Indicator
     * @returns an HTML template of all the steps in the flow
     */
    PvdProgressIndicator.prototype.renderSteps = function () {
        var _this = this;
        return x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), this.pvdSteps.length
            ? this.pvdSteps.map(function (step, stepIndex) {
                var stepState = _this.getStepState(stepIndex);
                return x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            <div role=\"listitem\" class=\"", "\">\n              ", " ", "\n            </div>\n          "], ["\n            <div role=\"listitem\" class=\"", "\">\n              ", " ", "\n            </div>\n          "])), _this.stepClassMap(stepState), _this.renderStepVisual(stepState), _this.renderLabel(step, stepState, stepIndex));
            })
            : A);
    };
    PvdProgressIndicator.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-progress-indicator-root"),
            modifierPrefix: 'pvd-progress-indicator',
            modifiers: [],
        };
        return x(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      <div class=\"", "\" role=\"list\" tabindex=\"-1\">", "</div>\n    "], ["\n      <div class=\"", "\" role=\"list\" tabindex=\"-1\">", "</div>\n    "])), getClassName(classMap), this.renderSteps());
    };
    //#region Component configuration
    PvdProgressIndicator.componentName = 'progress-indicator';
    __decorate([
        n({
            type: Number,
            reflect: true,
            attribute: 'pvd-active-step-index',
        }),
        __metadata("design:type", Number)
    ], PvdProgressIndicator.prototype, "pvdActiveStepIndex", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-a11y-prefix-text',
        }),
        __metadata("design:type", String)
    ], PvdProgressIndicator.prototype, "pvdA11yPrefixText", void 0);
    __decorate([
        n({
            type: Array,
            reflect: false,
            attribute: 'pvd-a11y-step-state-object',
        }),
        __metadata("design:type", Object)
    ], PvdProgressIndicator.prototype, "pvdA11yStepStateObject", void 0);
    __decorate([
        n({
            type: Array,
            reflect: false,
            attribute: 'pvd-steps',
        }),
        __metadata("design:type", Array)
    ], PvdProgressIndicator.prototype, "pvdSteps", void 0);
    return PvdProgressIndicator;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

export { DEFAULT_A11Y_PREFIX_TEXT, DEFAULT_ACTIVE_STEP_INDEX, ProgressIndicatorIconName, ProgressIndicatorStepState, PvdProgressIndicator };
